<ng-container>
    <fui-select-control *ngIf="mode === SelectControlMode.Default"
                        [options]="data"
                        [disabled]="readonly"
                        (clear)="clearHandler()"
                        [placeholder]="placeholder"
                        [label]="label"
                        [loading]="isLoading"
                        (select$)="select($event)"
                        [value]="selectControlValue"
                        (valueChange)="selectControlChanged($event)"
                        (focussed$)="onFocus($event)"
                        [valueField]="valueField"
                        [labelField]="labelField"
                        [control]="formControlValidation"
                        [internallyFilterable]="!customFiltering"
                        [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                        [allowClearSelectionOption]="allowClearSelectionOption"
                        [allowDirectInput]="allowDirectInput"
                        [isNumeric]="isNumeric"
                        [total]="totalRecords"
                        [actions]="actions"
                        (filtered$)="filtered($event)"
                        (removed$)="onRemove()"
                        [removable]="removable"
                        (extended$)="openExtendedSearch()"
                        (added$)="openAdd()"
                        (action$)="onAction.emit($event)"
                        (optionOpened$)="openView($event, true)"
                        [showExtendedSearchOption]="(extendedSearchComponent != undefined) && !hideExtendedSearchOption"
                        [showAddOption]="(extendedEditComponent != undefined || showAddOption) && !hideAddOption"
                        [showOptionOpenOption]="(extendedEditComponent != undefined || showOptionOpenOption) && !hideOptionOpenOption">
    </fui-select-control>
    <fui-autocomplete-control *ngIf="mode === SelectControlMode.Autocomplete"
                              [options]="data"
                              [disabled]="readonly"
                              [placeholder]="'wbo.edit.grid.add.quick-add.placeholder'"
                              [label]="label"
                              [loading]="isLoading"
                              [(value)]="selectControlValue"
                              (focussed$)="onFocus($event)"
                              [valueField]="valueField"
                              [labelField]="labelField"
                              [total]="totalRecords"
                              (filtered$)="filtered($event)"
                              (removed$)="onRemove()"
                              (extended$)="openExtendedSearch()"
                              [showExtendedSearchOption]="(extendedSearchComponent != undefined) && !hideExtendedSearchOption">
    </fui-autocomplete-control>
    <fui-select-nav *ngIf="mode === SelectControlMode.Navigation"
                    [options]="data"
                    [getOptionMetaData]="getOptionMetaData"
                    [disabled]="readonly"
                    [title]="label"
                    [loading]="isLoading"
                    (focussed$)="onFocus($event)"
                    [valueField]="valueField"
                    [labelField]="labelField"
                    [internallyFilterable]="!customFiltering"
                    [total]="totalRecords"
                    [actions]="actions"
                    (filtered$)="filtered($event)"
                    (selected$)="openView($event, true)"
                    (extended$)="openExtendedSearch()"
                    (added$)="openAdd()"
                    (action$)="onAction.emit($event)"
                    [showExtendedSearchOption]="(extendedSearchComponent != undefined) && !hideExtendedSearchOption"
                    [showAddOption]="(extendedEditComponent != undefined || showAddOption) && !hideAddOption">
    </fui-select-nav>
</ng-container>
